<script setup>
  import { RouterLink, useRouter } from 'vue-router'

  const props = defineProps({
    breadcrumbs: {
      type: Array,
      required: true,
    },
  })

  // Vue RouterのuseRouterを使用
  const router = useRouter()

  // ナビゲーションハンドラ
  const navigate = breadcrumb => {
    if (breadcrumb.url) {
      router.push(breadcrumb.url)
    } else if (breadcrumb.path) {
      router.push(breadcrumb.path)
    }
  }
</script>

<template>
  <footer class="app-footer">
    <ul>
      <li v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <a v-if="breadcrumb.url || breadcrumb.path" href="#" @click.prevent="navigate(breadcrumb)">
          {{ breadcrumb.name }}
        </a>
        <span v-else>{{ breadcrumb.name }}</span>
      </li>
    </ul>
  </footer>
</template>
